import { createTheme, ThemeProvider } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCarrier, getCarrierByBusinessName } from '../redux/action/carrier';
import { unwrapResult } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { setTheme } from '../redux/reducers/themeSlice';
import { useParams } from 'react-router-dom';

interface ThemeWrapperProps {
  children: React.ReactNode;
}

const isValidColor = (color: string): boolean => {
  const colorRegex = /^#([0-9A-Fa-f]{3}){1,2}$|^(rgb|rgba|hsl|hsla)\([^\)]*\)$/;
  return colorRegex.test(color);
};

const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
  const dispatch = useDispatch();
  const { primaryColor, secondaryColor } = useSelector((state: RootState) => state.theme);
  const businessName = localStorage.getItem('businessName');
  const validPrimaryColor = isValidColor(primaryColor) ? primaryColor : "#4A90E2";
  const validSecondaryColor = isValidColor(secondaryColor) ? secondaryColor : "#A8E6FF";
  const theme = createTheme({
    palette: {
      primary: {
        main: validPrimaryColor,
      },
      secondary: {
        main: validSecondaryColor,
      },
    },
  });
  useEffect(() => {
    if (businessName) {
      dispatch<any>(getCarrierByBusinessName(businessName))
        .then(unwrapResult)
        .then((res: any) => {
          const colorHex = res.color_hex;
          if (isValidColor(colorHex)) {
            dispatch(setTheme({ primaryColor: colorHex, secondaryColor: '#4A90E2' }));
          } else {
            console.error('Invalid color fetched:', colorHex);
          }
        })
        .catch((err: any) => {
          console.error('Failed to fetch color_hex:', err);
        });
    } else {
      console.error('business or undefined');
    }
  }, [businessName, dispatch]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeWrapper;
